import { network } from '@root/utils'
import { handleReturn, MutationFunction, QueryFunction } from '../root'

export interface IElsterLatestFiling {
  accepted_at: string
  start_date: string
  end_date: string
  transfer_ticket?: string | null
}

export interface IElsterCertificateStatusResponse {
  has_certificate: boolean
  is_valid: boolean
  label?: string | null
  id?: number
  updated_at?: string
  latest_filing?: IElsterLatestFiling | null
}

interface IElsterCertificateStatusRequest {
  slug: string
}

export const fetchElsterCertificateStatus: QueryFunction<
  IElsterCertificateStatusRequest,
  IElsterCertificateStatusResponse
> = async ({ slug }) => {
  const url = `/v1/integrations/business/${slug}/elster/certificate/status/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET'
  })
  return data
}

interface IUploadElsterCertificateProps {
  slug: string
}

export interface IElsterCertificateUploadValues {
  pfx_b64: string
  pin: string
  label?: string
}

export const uploadElsterCertificate: MutationFunction<
  IUploadElsterCertificateProps,
  IElsterCertificateUploadValues
> = async ({ slug }, data) => {
  const url = `/v1/integrations/business/${slug}/elster/certificate/`
  const { status, data: responseData } = await network.httpClient.request({
    url,
    method: 'POST',
    data: {
      pfx_b64: data.pfx_b64,
      pin: data.pin,
      label: data.label || ''
    },
    validateStatus: () => true
  })
  return handleReturn({ status, data: responseData })
}

interface IElsterCertificateCheckRequest {
  slug: string
}

export interface IElsterCertificateCheckResponse {
  ok: boolean
  has_certificate: boolean
}

export const checkElsterCertificate: QueryFunction<
  IElsterCertificateCheckRequest,
  IElsterCertificateCheckResponse
> = async ({ slug }) => {
  const url = `/v1/business/${slug}/vat_period/has_elster_certificate/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET'
  })
  return data
}
